import { initSDK, wsgParams } from '@didi/wsgsdk';
import qs from 'qs';
import wsgConfig from './wsgConfig';

class WsgEnv {
  constructor(options) {
    const { appId, env, uid } = options;
    this.appId = appId;
    this.env = env;
    this.uid = uid;
    this.wsgenv = '';

    this.initWsgSDK();
  }

  initWsgSDK() {
    try {
      initSDK({
        appId: this.appId,
        env: this.env,
        uid: this.uid,
      });
    } catch {}
  }

  getWsgEnv({ url, bfield = {} }) {
    return new Promise((resolve, reject) => {
      try {
        wsgParams({ url, bfield }, (wsgenv) => {
          this.wsgenv = wsgenv;
          resolve(wsgenv);
        });
      } catch {
        reject();
      }
    });
  }

  async wsgEnvToQuery(config) {
    await this.getWsgEnv({ url: config.url });
    config.params.wsgenv = this.wsgenv;
    return config;
  }

  async wsgEnvToBody(config) {
    await this.getWsgEnv({ url: config.url });
    if (!this.wsgenv) return config;
    const params = this.getDataObject(config.data);
    params.wsgenv = this.wsgenv;
    config.data = this.setDataString(params);
    return config;
  }

  getDataObject(data) {
    return qs.parse(data);
  }

  setDataString(data) {
    return qs.stringify(data);
  }

  async wsgEnvToServer(config) {
    await this.wsgEnvToBody(config);
    // await this.wsgEnvToQuery(config)
    return config;
  }
}

// let wsgEnv = new WsgEnv(wsgConfig.online);
let wsgEnv = new WsgEnv(wsgConfig.online);

export default wsgEnv;
